module.exports = "/assets/data/e6de7ee4abc00b253ffb8af5cb515915-MK11.data.json";